<template>
  <div class="d-flex justify-content-around h-100 w-100 mobile-nav-item-container">
    <router-link
        v-slot="{ href, route, navigate, isActive, isExactActive }"
        :to="{ name: 'Welcome', params: { uuid: id } }"
    >
      <div
          :class="[isActive && 'active', isExactActive && 'exact-active']"
          class="mobile-nav-item"
          @click="navigate"
      >
        <div class="mobile-nav-icon">
          <i class="far fa-2x fa-download"></i>
        </div>
        <div>{{ 'Download' | trans }}</div>
      </div>
    </router-link>
    <router-link
        v-slot="{ href, route, navigate, isActive, isExactActive }"
        :to="{ name: 'FileList', params: { uuid: id } }"
    >
      <div
          :class="[isActive && 'active', isExactActive && 'exact-active']"
          class="mobile-nav-item"
          @click="navigate"
      >
        <div class="mobile-nav-icon">
          <i class="far fa-list fa-2x"></i>
        </div>
        <div>{{ 'Files' | trans }}</div>
      </div>
    </router-link>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';

export default {
  name: 'MobileNavbar',
  props: {},
  components: {},
  mixins: [store, currentJob],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {},
};
</script>
<style lang="scss">
.mobile-nav-item-container {
  gap: 0px;
  align-items: stretch;
  justify-content: center;
}

.mobile-nav-item {
  height: 100%;
  align-items: center;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: black;
  justify-content: center;

  &.active {
    color: white;
    background: #1266F1;
  }

  .mobile-nav-icon {
    height: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
